'use strict';

class BulkDownloader {
  constructor() {
    'ngInject';

    this.restrict = 'A';
    this.scope = {
      filename: '=',
      csvGenerator: '='
    }
  }

  link(scope, element) {
    let downloadLink = document.createElement('a');
    scope.$watch('filename', value => {
      downloadLink.setAttribute('download', value);
    });

    element.on('click', () => {
      scope.csvGenerator()
        .then(csv => {
          let bom = new Uint8Array([0xEF, 0xBB, 0xBF]);
          let blob = new Blob([bom, csv], {
              type: "text/csv;charset=utf-8"
          });

          if(window.navigator.msSaveBlob) {
            window.navigator.msSaveBlob(blob, scope.filename);
          } else {
            let csvURL = window.URL.createObjectURL(blob);
            downloadLink.setAttribute('href', csvURL);

            document.body.appendChild(downloadLink);
            downloadLink.click();
            document.body.removeChild(downloadLink);
          }
        });
    });
  }
}

export default angular.module('leptonApp.bulkDownloader', [])
  .directive('bulkDownloader', [() => new BulkDownloader()])
  .name;



// WEBPACK FOOTER //
// ./public/dev/components/directive/csv_downloader/bulk_downloader.directive.js